import { Controller } from "@hotwired/stimulus"

// Collapsible "Filter reviews" menu on the book/user review pages.
// Mirrors the look of the Explore "Filter Books" menu but uses the review
// pages' Turbo-frame plumbing rather than the legacy remote-form approach.
export default class extends Controller {
  static targets = ["form", "chevron", "noRating", "ratingRange", "dnf", "withWritten", "withoutWritten"]

  toggle() {
    if (!this.hasFormTarget) return
    // Derive the chevron state from the form's actual visibility so the two
    // can never drift out of sync (e.g. if toggle fires twice during a swap).
    const nowHidden = this.formTarget.classList.toggle("hidden")
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle("rotate-90", !nowHidden)
  }

  // "No rating" is mutually exclusive with a chart star-bucket / DNF. When it's
  // ticked, disable the round-tripped rating_range/dnf hidden fields so they
  // aren't submitted (keeps the resulting URL clean).
  noRatingChanged() {
    const disable = this.hasNoRatingTarget && this.noRatingTarget.checked
    if (this.hasRatingRangeTarget) this.ratingRangeTarget.disabled = disable
    if (this.hasDnfTarget) this.dnfTarget.disabled = disable
  }

  // "with" and "without a written explanation" are opposites — ticking one unticks the other.
  withWrittenChanged() {
    if (this.hasWithWrittenTarget && this.withWrittenTarget.checked && this.hasWithoutWrittenTarget) {
      this.withoutWrittenTarget.checked = false
    }
  }

  withoutWrittenChanged() {
    if (this.hasWithoutWrittenTarget && this.withoutWrittenTarget.checked && this.hasWithWrittenTarget) {
      this.withWrittenTarget.checked = false
    }
  }
}
